import { createFeatureSelector, createSelector } from '@ngrx/store';

import { appFeatureKey } from 'app/state/app-state/app-state.reducer';
import { AppState } from 'app/state/app-state/app.state';

export const selectAppState = createFeatureSelector<AppState>(appFeatureKey);

export const selectActiveDialogs = createSelector(selectAppState, (state) => state.activeDialogs);
